//@flow

type Sector = {
  value: string,
  title: string,
};

const getCity = (sectors: Sectors) => (code: string): string => {
  const foundSector: Sector = sectors.find(
    sector => sector.value.toLowerCase() === code.toLowerCase()
  );

  if (foundSector) return foundSector.title;
  return '';
};

const getCityCode = (sectors: Sectors) => (city: string): string => {
  const foundSector: Sector = sectors.find(
    sector => sector.title.toLowerCase() === city.toLowerCase()
  );

  if (foundSector) return foundSector.value;
  return '';
};

/**
 *
 * @see {link} https://stackoverflow.com/questions/13898423/javascript-convert-24-hour-time-of-day-string-to-12-hour-time-with-am-pm-and-no
 */

function convertInto1200Hrs(time24) {
  let ts = time24;
  let H = +ts.substr(0, 2);
  let h = H % 12 || 12;
  h = h < 10 ? '0' + h : h;
  ts = h + ts.substr(2, 3);

  return ts;
}

function getAmOrPm(dateString: string): string {
  const hr = Number(dateString.split(':')[0]);

  return hr >= 12 ? 'pm' : 'am';
}

/**
 * @see {link} https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */

const isMobile = {
  Android: () => navigator.userAgent.match(/Android/i),
  BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
  iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
  Opera: () => navigator.userAgent.match(/Opera Mini/i),
  Windows: () => navigator.userAgent.match(/IEMobile/i),

  any: () => {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

const getTotalHoneyguideCredit = (inbound: any, outbound: any) => {
  let honeyguideCredit = null;

  if (outbound) {
    honeyguideCredit += Number(outbound.promocodeAmount);
  }

  if (inbound) {
    honeyguideCredit += Number(inbound.promocodeAmount);
  }

  return honeyguideCredit;
};

const getFrontUrl = (pathname: string, index: number = -1) =>
  pathname
    .split('/')
    .slice(0, index)
    .join('/');

export {
  getCity,
  getCityCode,
  getAmOrPm,
  isMobile,
  convertInto1200Hrs,
  getFrontUrl,
  getTotalHoneyguideCredit,
};



// WEBPACK FOOTER //
// ./src/screens/Flights/helpers.js